// Configuration object
interface Config {
  ENV_MODE: string;
  IS_LOCAL: boolean;
  SUBSCRIPTION_TIERS: {
    FREE: { priceId: string };
    TIER_2_20: { priceId: string };
    TIER_2_20_YEARLY: { priceId: string };
    TIER_6_50: { priceId: string };
    TIER_6_50_YEARLY: { priceId: string };
    TIER_12_100: { priceId: string };
    TIER_12_100_YEARLY: { priceId: string };
    TIER_25_200: { priceId: string };
    TIER_25_200_YEARLY: { priceId: string };
    TIER_50_400: { priceId: string };
    TIER_50_400_YEARLY: { priceId: string };
    TIER_125_800: { priceId: string };
    TIER_125_800_YEARLY: { priceId: string };
    TIER_200_1000: { priceId: string };
    TIER_200_1000_YEARLY: { priceId: string };
  };
}

export const config: Config = {
  ENV_MODE: process.env.NEXT_PUBLIC_ENV_MODE || 'cloud',
  IS_LOCAL: process.env.NEXT_PUBLIC_ENV_MODE === 'local',
  SUBSCRIPTION_TIERS: {
    FREE: { priceId: process.env.NEXT_PUBLIC_STRIPE_FREE_PRICE_ID || '' },
    TIER_2_20: { priceId: process.env.NEXT_PUBLIC_STRIPE_TIER_2_20_PRICE_ID || '' },
    TIER_2_20_YEARLY: { priceId: process.env.NEXT_PUBLIC_STRIPE_TIER_2_20_YEARLY_PRICE_ID || '' },
    TIER_6_50: { priceId: process.env.NEXT_PUBLIC_STRIPE_TIER_6_50_PRICE_ID || '' },
    TIER_6_50_YEARLY: { priceId: process.env.NEXT_PUBLIC_STRIPE_TIER_6_50_YEARLY_PRICE_ID || '' },
    TIER_12_100: { priceId: process.env.NEXT_PUBLIC_STRIPE_TIER_12_100_PRICE_ID || '' },
    TIER_12_100_YEARLY: { priceId: process.env.NEXT_PUBLIC_STRIPE_TIER_12_100_YEARLY_PRICE_ID || '' },
    TIER_25_200: { priceId: process.env.NEXT_PUBLIC_STRIPE_TIER_25_200_PRICE_ID || '' },
    TIER_25_200_YEARLY: { priceId: process.env.NEXT_PUBLIC_STRIPE_TIER_25_200_YEARLY_PRICE_ID || '' },
    TIER_50_400: { priceId: process.env.NEXT_PUBLIC_STRIPE_TIER_50_400_PRICE_ID || '' },
    TIER_50_400_YEARLY: { priceId: process.env.NEXT_PUBLIC_STRIPE_TIER_50_400_YEARLY_PRICE_ID || '' },
    TIER_125_800: { priceId: process.env.NEXT_PUBLIC_STRIPE_TIER_125_800_PRICE_ID || '' },
    TIER_125_800_YEARLY: { priceId: process.env.NEXT_PUBLIC_STRIPE_TIER_125_800_YEARLY_PRICE_ID || '' },
    TIER_200_1000: { priceId: process.env.NEXT_PUBLIC_STRIPE_TIER_200_1000_PRICE_ID || '' },
    TIER_200_1000_YEARLY: { priceId: process.env.NEXT_PUBLIC_STRIPE_TIER_200_1000_YEARLY_PRICE_ID || '' },
  }
};

export const isLocalMode = () => config.ENV_MODE === 'local';
